import React from 'react';
import { Providers } from '@/components/Auth/utils';
import { SignInProviders } from '@/components/Auth/SignIn/SignIn';

export const SignIn = ({
  isPopUp = false,
  callbackUrl,
}: {
  isPopUp?: boolean;
  callbackUrl?: string;
}) => {
  const providers: Providers[] = [
    'github',
    'gitlab',
    'gitlab-self-hosted',
    'bitbucket',
  ];
  return (
    <SignInProviders
      providers={providers}
      isPopUp={isPopUp}
      callbackUrl={callbackUrl}
    />
  );
};
